/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

import Loader from "../components/Loader/Loader";

export const IframeTester: RankedTester = rankWith(4, uiTypeIs("Iframe"));

function IframeRenderer({ uischema, visible }: RendererProps) {
  const height = uischema.options?.spectrumProps?.height;
  const width = uischema.options?.spectrumProps?.width || "100%";
  const urlLink = uischema.options?.url;
  const className = uischema.options?.ClassName;
  const style = uischema.options?.style;

  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    const iframeElement: any = document.getElementById("iframeDiv");
    iframeElement?.addEventListener("load", () => {
      setIsloading(true);
      iframeElement.style.opacity = 1;
      iframeElement.style.height = height || "auto";
    });
  }, []);

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div data-testid="iframe-test-id" hidden={!componentVisibility}>
      {!isLoading && <Loader />}
      <section>
        <iframe
          id="iframeDiv"
          title={urlLink}
          src={urlLink}
          width={width}
          className={className}
          style={{ ...style, opacity: 0 }}
        />
      </section>
    </div>
  );
}

export default withJsonFormsLayoutProps(IframeRenderer);
